import React from "react";
import "./css/packages.css";

import PackagesHeader from "./extra-content/PackagesHeader";
import CardContainer from "./extra-content/CardContainer";
import Card from "./extra-content/Card";

// card images
import CardImage from "./extra-content/CardImage";
import CardImage2 from "./extra-content/CardImage2";
import CardImage3 from "./extra-content/CardImage3";

import CardText from "./extra-content/CardText";

function Packages() {
  return (
    <div className="display-flex" id="packages-container">
      <PackagesHeader />
      <CardContainer>

        {/* Enrollee */}
        <Card>  
          <CardImage></CardImage>
          <CardText
            title="ENROLEE"
            text="Our HMO provides a platform for you and your family to enjoy the health care packages that we offer and track every information you need to know."
          ></CardText>
        </Card>

        {/* Company */}
        <Card>
          <CardImage2></CardImage2>
          <CardText
            title="COMPANY"
            text="We offer convenience in providing the health care packages for company staff. Careplus ensures that staff have quick aceess to treatment packages at registered health centres."
          ></CardText>
        </Card>

        {/* Provider */}
        <Card>
          <CardImage3></CardImage3>
          <CardText
            title="PROVIDER"
            text="Our HMO provides a platform for registered health centres to provide health services to registered customers in the most covenient way."
          ></CardText>
        </Card>
      </CardContainer>
    </div>

  );
}

export default Packages;
